<div *ngIf='!IsShowDetail'>
  <div>
    <div class="row card-deck">
      <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form">
        <!--<div class="modal-header">
          <h4 class="modal-title">Profile Summary</h4>
          <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>-->
        <h5 class="card-title">
          Profile Summary
          <button type="button" class="close" data-dismiss="modal"
                  (click)="activeModal.dismiss('Cross click')"
                  aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </h5>
        <div>
          <!-- Form actions layout section start -->

          <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


            <div class="card-body" >
              <div class="row">
                <div class="form-group col-md-12 col-xs-12">
                  <!--<label for="eventInput2">Profile Summary</label>-->
                  <textarea type="text"  class="form-control"  rows="4"  id="CurrentActorProfileSummaryRequest.ProfileSummary"
                         [(ngModel)]="CurrentActorProfileSummaryRequest.ProfileSummary"
                         name="CurrentActorProfileSummaryRequest.ProfileSummary"
                           
                         placeholder="Profile Summary" maxlength="1000" ></textarea>
                </div>
              </div>
              <!--<div class="form-group">
                <div class="col-md-12">
                  <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                </div>
              </div>-->


            </div>

            <div class="modal-footer">
              <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-primary">Submit</button>

            </div>
          </form>

          <!-- // Form actions layout section end -->
        </div>


        <!--<div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
        </div>-->
      </div>
</div>
</div>
</div>
